export const cotaOrExtra = new Set();

export function isCotaOrExtra(isLive, sportId, aggId) {
    return cotaOrExtra.has(`${isLive ? 'lv' : 'pr'}_${sportId}_${aggId}`);
}
